import { render } from "./CocomoniDetail.vue?vue&type=template&id=30aefadc&scoped=true"
import script from "./CocomoniDetail.vue?vue&type=script&lang=js"
export * from "./CocomoniDetail.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./CocomoniDetail.vue?vue&type=style&index=0&id=30aefadc&lang=scss&module=true"
cssModules["$style"] = style0
import "./CocomoniDetail.vue?vue&type=style&index=1&id=30aefadc&lang=scss&scoped=true"

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__scopeId',"data-v-30aefadc"]])

export default __exports__